<template>
  <base-box title="Bestellabschluss">
    <div class="checkbox mb-3">
      <label class="d-flex gap-2">
        <input v-model="agbChecked" type="checkbox" name="agbCheck" />
        <div class="check"></div>
        <span>
          Ich stimme den <a href="/conditions" target="_blank">AGBs</a> zu und nehme die
          <a href="/privacy" target="_blank">Datenschutzerklärung</a> zur Kenntnis.
        </span>
      </label>
    </div>

    <base-form-button
      v-if="menu == null || menu.attributes?.total != '0,00 €'"
      label="Jetzt kostenpflichtig bestellen"
      classes="d-block btn btn-lg btn-primary mx-auto px-5"
      :disabled="!(agbChecked && !disabled)"
      @trigger-action="agbChecked && !disabled && $emit('submit')"
    ></base-form-button>
    <base-form-button
      v-else
      label="Jetzt bestellen"
      classes="d-block btn btn-lg btn-primary mx-auto px-5"
      :disabled="!(agbChecked && !disabled)"
      @trigger-action="agbChecked && !disabled && $emit('submit')"
    ></base-form-button>
  </base-box>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    menu: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ['submit'],
  setup() {
    const agbChecked = ref(false);
    return { agbChecked };
  },
};
</script>

<style lang="scss" scoped></style>
